export const MODAL_DIALOG_TEST_ID = 'command-palette.ui.modal.modal-dialog';
